import {
  HIDE_NOTICES_LOADER,
  SHOW_NOTICES_LOADER,
  GET_NOTICES_SUCCESS,
  GET_NOTICES_NEW_LIST_SUCCESS,
  CLEAR_NOTICES_REDUCER,
  GET_UNREAD_NOTICES_SUCCESS,
  GET_NOTICE_BY_ID_SUCCESS,
  GET_NOTICE_DELIVERY_STATUS_SUCCESS,
  CLEAR_NOTICE_DELIVERY_STATUS,
  HIDE_NOTICES_DETAILS_LOADER,
  SHOW_NOTICES_DETAILS_LOADER,
  CLEAR_NOTICES_UNREAD_COUNT,
  SEND_NOTICE_RESPONSE_SUCCESS,
  SEND_NOTICE,
  SEND_NOTICE_SUCCESS,
  SEND_NOTICE_FAILURE,
  SET_NOTICES_HISTORY_FILTERS,
  SET_SELECTED_NOTICE,
  GET_NOTIFICATION_RECEIVERS_SUCCESS,
  GET_NOTIFICATION_FILTER_OPTIONS_SUCCESS,
  GET_NOTIFICATION_TARGETS_SUCCESS,
  GET_NOTIFICATION_TARGETS,
  GET_NOTIFICATION_TARGETS_FAILURE,
} from 'constants/ActionTypes';

const INIT_STATE = {
  loading: false,
  noticeDetails: null,
  loadingDetails: false,
  isModalLoading: false,
  notices: {
    list: null,
    pageCount: 0,
  },
  deliveryStatusArray: null,
  unreadCount: 0,
  historyFilters: {
    startPeriod: '',
    endPeriod: '',
  },
  selectedNotice: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CLEAR_NOTICE_DELIVERY_STATUS: {
      return {
        ...state,
        deliveryStatusArray: null,
      };
    }
    case GET_NOTICE_DELIVERY_STATUS_SUCCESS: {
      return {
        ...state,
        deliveryStatusArray: action.payload.data.filter(n => n.receiver),
      };
    }
    case GET_NOTICE_BY_ID_SUCCESS: {
      return {
        ...state,
        noticeDetails: action.payload.notice,
      };
    }
    case GET_UNREAD_NOTICES_SUCCESS: {
      return {
        ...state,
        unreadCount: action.payload,
      };
    }
    case GET_NOTICES_NEW_LIST_SUCCESS: {
      const { entities, pageCount } = action.payload;

      return {
        ...state,
        notices: {
          list: entities,
          pageCount,
        },
      };
    }

    case GET_NOTICES_SUCCESS: {
      const { entities, pageCount } = action.payload;

      return {
        ...state,
        notices: {
          list: !state.notices.list ? entities : [...state.notices.list, ...entities],
          pageCount,
        },
      };
    }
    case SHOW_NOTICES_LOADER: {
      return {
        ...state,
        loading: true,
      };
    }
    case HIDE_NOTICES_LOADER: {
      return {
        ...state,
        loading: false,
      };
    }
    case SHOW_NOTICES_DETAILS_LOADER: {
      return {
        ...state,
        loadingDetails: true,
      };
    }
    case HIDE_NOTICES_DETAILS_LOADER: {
      return {
        ...state,
        loadingDetails: false,
      };
    }
    case CLEAR_NOTICES_REDUCER: {
      return {
        ...INIT_STATE,
        unreadCount: state.unreadCount,
      };
    }
    case CLEAR_NOTICES_UNREAD_COUNT: {
      return {
        ...state,
        unreadCount: 0,
      };
    }
    case SEND_NOTICE_RESPONSE_SUCCESS: {
      return {
        ...state,
        noticeDetails: {
          ...state.noticeDetails,
          response: action.payload.response,
        },
      };
    }
    case SEND_NOTICE: {
      return {
        ...state,
        isModalLoading: true,
      };
    }
    case SEND_NOTICE_FAILURE: {
      return {
        ...state,
        isModalLoading: false,
      };
    }
    case SEND_NOTICE_SUCCESS: {
      return {
        ...state,
        isModalLoading: false,
      };
    }
    case GET_NOTIFICATION_RECEIVERS_SUCCESS: {
      return {
        ...state,
        receivers: action.payload.receivers,
      };
    }
    case GET_NOTIFICATION_FILTER_OPTIONS_SUCCESS: {
      return {
        ...state,
        filters: action.payload.filterOptions,
      };
    }
    case GET_NOTIFICATION_TARGETS: {
      return {
        ...state,
        targetsLoading: true,
      };
    }
    case GET_NOTIFICATION_TARGETS_SUCCESS: {
      return {
        ...state,
        targets: action.payload.targets,
        targetsLoading: false,
      };
    }
    case GET_NOTIFICATION_TARGETS_FAILURE: {
      return {
        ...state,
        targets: [],
        targetsLoading: false,
      };
    }
    case SET_NOTICES_HISTORY_FILTERS: {
      return {
        ...state,
        historyFilters: action.payload,
      };
    }
    case SET_SELECTED_NOTICE: {
      return {
        ...state,
        selectedNotice: action.payload,
      };
    }
    default:
      return state;
  }
};
